import { colors, layout, typography } from '@justgiving/carepack-design-tokens';

export const pageCreationTheme = {
  name: 'Page Creation Theme',
  color: {
    purple: colors.colorPurpleBase,
    purple300: colors.colorPurple300,
    purple400: colors.colorPurple400,
    purple600: colors.colorPurple600,
    blue: colors.colorBlueBase,
    blue300: colors.colorBlue300,
    blue500: colors.colorBlue500,
    blue600: colors.colorBlue600,
    green300: colors.colorGreen300,
    green500: colors.colorGreen500,
    green: colors.colorGreenBase,
    grey300: colors.colorGrey300,
    grey400: colors.colorGrey400,
    grey600: colors.colorGrey600,
    neutral: colors.colorNeutralBase,
    neutral400: colors.colorNeutral400,
    neutral500: colors.colorNeutral500,
    neutral600: colors.colorNeutral600,
    orange600: colors.colorOrange600,
    orange300: colors.colorOrange300,
    orange: colors.colorOrangeBase,
    red: colors.colorRedBase,
    red300: colors.colorRed300,
    red500: colors.colorRed500,
    white: colors.colorWhite,
    brandPrimary: colors.colorPurpleBase,
    brandInteraction: colors.colorBlueBase,
  },

  font: {
    weight: {
      medium: typography.fontWeightMedium,
      regular: typography.fontWeightRegular,
      light: typography.fontWeightLight,
    },
    size: {
      ...typography,
    },
    family: "'Roboto', sans-serif",
  },
  layout: { ...layout, sizeSpacing00: 0 },
  mediaQuery: {
    mq376: '376px',
    mq592: '592px', // breakpoint at standard content width + margin
    mq768: '768px',
  },
  zIndex: {
    skipLink: 175,
    modal: 150,
    overlay: 125,
    sticky: 15,
    dropdown: 10,
    components: 5,
  },
};
